/**
 * Interaction / preview modes passed from SVG interaction hooks to ProductPreview.
 *
 * These are logic constants, not UI labels.
 */
export const PRODUCT_PREVIEW_MODE = {
  NORMAL:        'normal',
  SOLD:          'sold',
  FILTERED:      'filtered',
  FILTERED_SOLD: 'filtered-sold',
  HIDDEN:        'hidden',
  OTHER_STAGE:   'other-stage',
}

export const PRODUCT_PREVIEW_KIND = {
    POPOVER: 'popover',
    PANEL: 'panel',
    BOTTOM_SHEET: 'bottom_sheet',
}